// extracted by mini-css-extract-plugin
export default {"tile":"styles_tile__6jFKY","tile__header":"styles_tile__header__tQ5zi","tile__body":"styles_tile__body__o71YO","tile__footer":"styles_tile__footer__dyyDo"};